export default "__VITE_ASSET__WfKFI7Q7__"